import { render, staticRenderFns } from "./PoolPreviewStandard.vue?vue&type=template&id=5bd348e4"
import script from "./PoolPreviewStandard.vue?vue&type=script&lang=ts"
export * from "./PoolPreviewStandard.vue?vue&type=script&lang=ts"
import style0 from "./PoolPreviewStandard.vue?vue&type=style&index=0&id=5bd348e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports